var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "rd86yb9gqa",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.855826 0 0 0 0 0.195840 0 0 0 0 0.165660 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#rd86yb9gqa)",
    transform: "translate(-55.000000, -747.000000) translate(36.000000, 739.000000) translate(19.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03 0 0 4.028 0 9c0 4.97 4.03 9 9 9s9-4.03 9-9c0-4.972-4.03-9-9-9zm0 16.532c-4.162 0-7.533-3.372-7.533-7.532 0-4.162 3.37-7.534 7.533-7.534 4.16 0 7.532 3.373 7.532 7.534.001 4.16-3.373 7.532-7.532 7.532z",
    transform: "translate(0.000609, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.257 6.791L7.727 6.791 7.727 6.795 6.786 6.795 6.786 8.266 7.727 8.266 7.727 13.518 6.728 13.518 6.728 14.924 7.727 14.924 7.727 14.933 10.257 14.933 10.257 14.924 11.085 14.924 11.085 13.518 10.257 13.518zM8.975 5.792c.85 0 1.365-.565 1.365-1.266-.017-.714-.516-1.262-1.331-1.262-.814 0-1.348.547-1.348 1.262 0 .7.516 1.266 1.314 1.266z",
    transform: "translate(0.000609, 0.000000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemInfo);
export default __webpack_public_path__ + "static/media/system-info.257f1f91.svg";
export { ForwardRef as ReactComponent };